// extracted by mini-css-extract-plugin
module.exports = {"button":"SunBumSpfButton_button__8zXoJ","buttonStartIcon":"SunBumSpfButton_buttonStartIcon__LGFL_","buttonEndIcon":"SunBumSpfButton_buttonEndIcon__MItfE"};